<template>
     <div class="index-main" >
        <div style="position: relative;width: 100%;">
            <el-image  :src="url+'/storage/'+data_info.shop_pic" fit="fill" style="position: relative;">
                <div slot="error" class="image-slot">
                    <img style="height:185px;" src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png">
                </div>
            </el-image>
            <div 
                class="biaozhu_yangshi"  
                v-for=" (itme1,index) of biaozhu" 
                :key="itme1.id" 
                :style="{left:(itme1.pos_left-10)*0.13333+'vw',top:(itme1.pos_top-10)*0.13333+'vw'}"
                @click="tiaozhuan(index)"
            >
                <el-tooltip   placement="right" :content="itme1.title === ''||itme1.title === 'null' ? '暂无名称':itme1.title" visible-arrow="false">
                    <span class="biaozhu_zi">{{index+1}}</span>   
                </el-tooltip>
            
            </div>
              
        </div>
        <!--    商品分类-->
        <!--    <div class="division">-->
        <!--      商品分类-->
        <!--    </div>-->
        <!--    <div class="classification">-->
        <!--      <el-row :gutter="20">-->
        <!--        <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item,index) in data_info.goods_cate" :key="index">-->
        <!--          <div class="detailed" @click="Goods_s(item)">-->
        <!--            <a>{{ item.label }}</a>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--      </el-row>-->
        <!--    </div>-->

        <!--    服务分类-->
        <!--    <div class="division" >-->
        <!--      服务分类-->
        <!--    </div>-->
        <!--    <div class="classification">-->
        <!--      <el-row :gutter="20">-->
        <!--        <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item,index) in data_serve" :key="index">-->
        <!--          <div class="detailed" @click="Serv_s(item)">-->
        <!--            <a>{{item.label}}</a>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--      </el-row>-->
        <!--    </div>-->


        <!--    产品库-->
<!--        el-image v-if="data_info.nav_color==='theme_red'" :src="'../../../../assets/home/shops/wei_red.png'"></el-image>&ndash;&gt;&ndash;&gt;-->
        <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_blue'"-->
        <!--                   src="../../../../assets/home/dingwei.png"/>-->
        <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_red'"-->
        <!--                   src="../../../../assets/home/shops/wei_red.png"/>-->
        <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_orange'"-->
<!--   点击查看我的产品库-->
        <div  v-if="data_info.nav_color==='theme_blue'">
            <div class="library"   >
                <el-button @click="dj_chanpin(data_info.uid,'')" style="font-size: 24px;background-color: #4E6EF2;color: #f0f0f0">
                    点击查看我的产品库
                </el-button>
            </div >
        </div>
        <div  v-if="data_info.nav_color==='theme_red'">
            <div class="library"   >
                <el-button @click="dj_chanpin(data_info.uid,'')" style="font-size: 24px;background-color:#ed3a3d;color: #f0f0f0 ">
                    点击查看我的产品库
                </el-button>
            </div >
        </div>
        <div  v-if="data_info.nav_color==='theme_orange'">
            <div class="library"   >
                <el-button @click="dj_chanpin(data_info.uid,'')" style="font-size: 24px;background-color: #e86419;color: #f0f0f0">
                    点击查看我的产品库
                </el-button>
            </div >
        </div>
        <el-dialog title="产品库" :visible.sync="dialogVisible" v-if="dialogVisible"
                   :append-to-body="true" :lock-scroll="false" width="1300px">
            <pinpai :nav_id1="nav_id1" :nav_id="nav_id"></pinpai>
        </el-dialog>
        <div>
           <!--最新商品-->
        <div class="division" v-if="data_info.auth_info.type!==1">
            最新商品
        </div>
        <div class="classification" v-if="data_info.auth_info.type!==1">
            <el-row :gutter="20">
          <!--商品分类-->
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4">
                    <div class="shop">
                        <img src="../../../assets/home/shops/123-eryaxindahei-fcc.png"
                             style="width: 100%;height: 100%"/>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item,index) in shop.slice(0,4)" :key="index">
                    <a v-if="item.api_edition == 2202" v-bind:href="'#/dianpu_new/' + item.id">
                        <div class="shop">
                            <el-image style="height:185px;width: 100%" :src="url+'/storage/'+item.cover" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img style="height:185px"
                                         src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png">
                                </div>
                            </el-image>
                            <div style="width: 90%;margin-left: 5%;margin-top: 10px;">
                                <div style="color: #333333;
                                font-family: Source Han Sans CN;font-weight: bold">{{ item.title }}</div>
                                <!--              <div style="float: right;margin-top: 10px;color: #999999">发布者：{{ item.username }}</div>-->
                            </div>
                        </div>
                    </a>
                    <a v-else v-bind:href="'#/dianpu_index/' + item.id">
                        <div class="shop">
                            <el-image style="height:185px;width: 100%" :src="url+'/storage/'+item.cover" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img style="height:185px"
                                         src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png">
                                </div>
                            </el-image>
                            <div style="width: 90%;margin-left: 5%;margin-top: 10px;">
                                <div style="color: #333333;
                                font-family: Source Han Sans CN;font-weight: bold">{{ item.title }}</div>
                                <!--              <div style="float: right;margin-top: 10px;color: #999999">发布者：{{ item.username }}</div>-->
                            </div>
                        </div>
                    </a>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" style="float: right;">
                    <a :href="'#/shops/commodity/'+$route.params.id">
                        <div class="shop">
                            <div class="chkan">
                                查看更多
                                <img src="../../../assets/home/shops/d4ee4f869011bbf243a7edbd5fbc93e.png"/>
                            </div>
                        </div>
                    </a>
                </el-col>
            </el-row>
        </div>
<!--        在线服务-->
        <div class="division">
            在线服务
        </div>
        <div class="classification">
            <el-row :gutter="20">
<!--              在线服务显示-->
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4">
                    <div class="shop">
                        <img src="../../../assets/home/shops/123-eryaxindahei-d15.png"
                             style="width: 100%;height: 100%"/>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item,index) in fuwuzhi.slice(0,4)"
                        :key="index">
                    <a v-bind:href="'#/dianpu_details/' + item.id">
                        <div class="shop">
                            <el-image style="height:185px;width: 100%" :src="url+'/storage/'+item.cover" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img style="height:185px;width: 185px" src="../../../assets/wenzhangfengmian.png"
                                         alt="">
                                </div>
                            </el-image>
                            <div style="width: 90%;margin-left: 5%;margin-top: 10px;">
                                <div style="color: #333333;font-family: Source Han Sans CN;font-weight: bold">{{ item.title }}</div>
                            </div>
                        </div>
                    </a>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" style="float: right;">
                    <a :href="'#/shops/service/'+$route.params.id">
                        <div class="shop">
                            <div class="chkan">
                                查看更多
                                <img src="../../../assets/home/shops/d4ee4f869011bbf243a7edbd5fbc93e.png"/>
                            </div>
                        </div>
                    </a>
                </el-col>
            </el-row>
        </div>
        <div class="division">
            成功案例
        </div>
        <div class="classification">
            <el-row :gutter="20">
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4">
                    <div class="shop">
                        <img src="../../../assets/home/shops/123-eryaxindahei-63d.png"
                             style="width: 100%;height: 100%"/>
                    </div>
                </el-col>

                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item,index) in casezhi.slice(0,4)"
                        :key="index">
                    <a v-bind:href="'#/dianpu_casedetails/' + item.id">
                        <div class="shop">
                            <!--            {{casezhi}}-->
                            <el-image style="height:185px;width: 100%" :src="url+'/storage/'+item.pic" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img style="height:185px"
                                         src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png">
                                </div>
                            </el-image>
                            <div style="width: 90%;margin-left: 5%;margin-top: 10px;">
                                <div style="color: #333333;font-family: Source Han Sans CN;font-weight: bold">{{ item.title }}</div>
                            </div>
                        </div>
                    </a>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4" style="float: right;">
                    <a :href="'#/shops/case/'+$route.params.id">
                        <div class="shop">
                            <div class="chkan">
                                查看更多
                                <img src="../../../assets/home/shops/d4ee4f869011bbf243a7edbd5fbc93e.png"/>
                            </div>
                        </div>
                    </a>
                </el-col>
            </el-row>
        </div>
        <!-- 商品分类展示部分-->
                <div class="shangpin_list">
                    <div style="height: auto">
                        <div v-if="aa==1" style="margin:0 auto;position: relative">
                            <div class="classification_a">商品分类
                                <i class="el-icon-arrow-down" @click="xiala(aa=2)"
                                   style="font-size: 16px; color: #8c8c8c;
                                   position:relative;top: -55px;left: 100px;font-family: Source Han Sans CN;">更多</i></div>
                            <div class="classification_list">
                                <el-row style="height: 290px;overflow: hidden">
                                    <el-col v-for="(item,index) in data_info.goods_cate" :key="index">
                                        <div class="detailed" @click="Goods_s(item)">
                                            <a>{{ item.label }}</a>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <!--商品分类展示全部-->
                        </div>
                        <div style="margin:0 auto;position: relative" v-if="aa==2">
                            <div class="classification_a">商品分类
                                <i class="el-icon-arrow-down" @click="xiala(aa=1)"
                                   style="font-size: 16px; color: #8c8c8c; font-family: Source Han Sans CN;
                                   position:relative;top: -55px;left: 100px">更多</i></div>
                            <div class="classification_list">
                                <el-row style="height: auto">
                                    <el-col v-for="(item,index) in data_info.goods_cate" :key="index">
                                        <div class="detailed" @click="Goods_s(item)">
                                            <a>{{ item.label }}</a>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <!--    服务分类-->
                    <div class="fuwu_list" style="position: relative;">
                        <div v-if="bb==1">
                            <div class="classification_a">服务分类
                                <i class="el-icon-arrow-down" @click="fwxl(bb=2)"
                                   style="font-size: 16px; color: #8c8c8c;font-family: Source Han Sans CN;
                                    position:relative;top: -55px;left: 100px">更多</i>
                            </div>
                            <div class="classification_list">
                                <el-row style="height: 290px;overflow: hidden">
                                    <el-col v-for="(item,index) in data_serve" :key="index">
                                        <div class="detailed" @click="Serv_s(item)">
                                            <a>{{item.label}}</a>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <!--        服务分类展示全部-->
                        <div v-if="bb==2">
                            <div class="classification_a "> 服务分类
                                <i class="el-icon-arrow-down" @click="fwxl(bb=1)"
                                   style="font-size: 16px; color: #8c8c8c;font-family: Source Han Sans CN;
                                    position:relative;top: -55px;left: 100px">更多
                                </i></div>
                            <div class="classification_list">
                                <el-row>
                                    <el-col v-for="(item,index) in data_serve" :key="index">
                                        <div class="detailed" @click="Serv_s(item)">
                                            <a>{{item.label}}</a>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <!--                    产品库-->
                    <div class="fuwu_list" style="position: relative;">
                        <div v-if="cc==1">
                            <div class="classification_a">产品库分类
                                <i class="el-icon-arrow-down" @click="fwxl(cc=2)"
                                   style="font-size: 16px; color: #8c8c8c;font-family: Source Han Sans CN;
                                    position:relative;top: -55px;left: 130px">更多</i>
                            </div>
                            <div class="classification_list">
                                <el-row style="height: 290px;overflow: hidden">
                                    <el-col v-for="(item1,index1) in auth_list" :key="index1">
                                        <div class="detailed">
                                            <el-button type="text" style="color: black" @click="dj_chanpin(data_info.uid,item1.name)">
                                                {{item1.name}}
                                            </el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <!--        产品库分类展示全部-->
                        <div v-if="cc==2">
                            <div class="classification_a "> 产品库分类
                                <i class="el-icon-arrow-down" @click="fwxl(cc=1)"
                                   style="font-size: 16px; color: #8c8c8c;font-family: Source Han Sans CN;
                                    position:relative;top: -55px;left: 130px">更多
                                </i></div>
                            <div class="classification_list">
                                <el-row>
                                    <el-col v-for="(item2,index2) in auth_list" :key="index2">
                                        <div class="detailed">
                                            <el-button type="text" style="color: black" @click="dj_chanpin(data_info.uid,item2.name)">
                                                {{item2.name}}
                                            </el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
  </div>
    </div>
</template>
<script>
    import pinpaizhanshi from "./pinpaizhanshi";
    export default {
        name: "category",
        data: function () {
            return {
                dialogVisible:false,
                url: '',
                casezhi: '',
                input: '',
                yemashu: '',
                zongshu: '',
                yemazhi: 1,
                information: '',
                shop: '',
                data_info: '',
                data_serve: '',
                value: '',
                aa: 1,
                bb: 1,
                cc: 1,
                nav_id1:'',
                nav_id:'',
                auth_list:[],
                data_uid:'',
                biaozhu:[],
                dianpu_id:''
   

            }
        },

        methods: {
            tiaozhuan(index){
                if(typeof(this.biaozhu[index].link)=='string'){
                    // 将link转化为字符串
                    let s = JSON.parse(this.biaozhu[index].link)
                    this.biaozhu[index].link = s
                }

                let links = this.biaozhu[index].link.links
                let value = this.biaozhu[index].link.value
                if(links == "/home.html#/shops/commodity"){
                    links = links + '/' + this.dianpu_id + '/' + value
                    window.open(links,"_self")
                    
                }else if(links == ""){
                    alert('暂无链接')
                }else{
                    window.open(links,'_self')
                }

            },
            xiala(aa) {
                console.log(aa)
            },
            fwxl(bb) {
                console.log(bb)
            },
            dj_chanpin(id,item_id){
              this.dialogVisible=true;
              this.nav_id1=id
              this.nav_id=item_id
            },
            Goods_s(item) {
                this.value = item.value;
                this.$router.push('/shops/commodity/' + this.data_info.id);
                this.$store.commit('changeclick', this.value);
            },
            Serv_s(item) {
                this.value = item.value;
                // this.$bus.$emit('sentvalue', this.value);
                this.$router.push('/shops/service/' + this.data_info.id);
                this.$store.commit('changeclick', this.value);
            },
            init() {
                var t = this
                t.list_data()
                this.url = window.config.api_url
                t.list_shop()
                t.list_info()
                t.list_serve()
                t.list_zaixainfuwu()
            },
            list_info() {
                var t = this
                var url = window.config.api_url + '/college/shop/info?id=' + this.$route.params.id
                t.axios.get(url).then(res => {
                    t.data_info = res.data;
                    t.data_uid = res.data.uid
                    t.biaozhu = res.data.mark
                    t.dianpu_id = res.data.id
                     t.list_cpk();
                })
            },
            list_serve() {
                var t = this;
                var url = window.config.api_url + '/college/shop/fuwu/cate?shop_id=' + this.$route.params.id;
                t.axios.get(url).then(res => {
                    t.data_serve = res.data;
                })
            },
            input_sj(e) {
                var t = this;
                t.input = e
                t.list_data()
            },
            list_data() {
                var t = this
                var url = window.config.api_url + '/college/shop/home/case?shop_id=' + this.$route.params.id + '&limit=4'
                t.axios.get(url).then(res => {
                    t.casezhi = res.data
                })

            },
            list_shop() {
                var t = this
                var url = window.config.api_url + '/college/shop/home/goods?shop_id=' + this.$route.params.id + '&limit=4'
                t.axios.get(url).then(res => {
                    t.shop = res.data
                })
            },
            list_zaixainfuwu() {
                var t = this
                var url = window.config.api_url + '/college/fuwu/list?shop_id=' + this.$route.params.id + '&limit=4'
                t.axios.get(url).then(res => {
                    t.fuwuzhi = res.data.data
                    // console.log(13456)
                    // console.log(res.data)
                })
            },
            yedianji(e) {
                this.yemazhi = e
                this.init()
            },
            fujiaxz(e) {
                this.$router.push(this.url + '/storage/' + e);
            },
            handleChange2(e) {
                this.$store.commit('savePath', e)

            },
          //产品库分类
          list_cpk(){
            var t = this;
            var url = window.config.api_url + '/college/ware/house/list?uid=' + this.data_uid;
            t.axios.get(url).then((res)=>{
              t.auth_list = res.data
            })
          },
        },
        components:{
          // '自己定于的名称'：引入的文件名
            'pinpai':pinpaizhanshi
            
        },

        created() {
            this.init() 
            
        },
    }

</script>
<style lang="less" scoped>
    a {
        text-decoration: none;
        cursor: pointer;
        
    }

    .index-main {
        margin-bottom: 200px;
        
    }

    .library {
      margin-right: auto;
      margin-left: auto;
      font-size: 24px;
      font-family: Source Han Sans CN;
      color: #333333;
      line-height: 55px;
      text-align: center;
    }

    .img {
        width: 100%;
        height: 400px;
        margin-bottom: 10px;
    }

    .division {
        width: 90%;
        max-width: 1200px;
        margin-right: auto;
        /*margin-left: auto;*/
        margin-left: 280px;
        //width: 97px;
        //height: 22px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 55px;
    }

    .classification {
        width: 90%;
        max-width: 1200px;
        margin-right: auto;
        margin-left:280px;
        margin-bottom: 30px;

        .detailed {
            text-align: center;
            width: 100%;
            //width: 100%;
            height: 46px;
            background: #FFFFFF;
            border-radius: 3px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 46px;
        }

        .shop {
            width: 100%;
            margin-top: 10px;
            height: 260px;
            background: #FFFFFF;
            border-radius: 3px;
            margin-bottom: 30px;
        }

        .chkan {
            text-align: center;
            line-height: 240px;
            //width: 65px;
            //height: 16px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #999999;
        }
    }

    .shangpin_list {
        float: left;
        margin-top: -1150px;
        margin-left: 50px;
        height: auto;

    }

    .classification_a {
        width: 90%;
        max-width: 1200px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 55px;
        margin-left: -30px;
    }

    .classification_list {
        width: 200px;
        margin-bottom: 20px;
        margin-left: -40px;
        margin-top: -50px;
        .detailed {
            text-align: center;
            width: 100%;
            margin-top: 10px;
            //width: 100%;
            height: 46px;
            background: #FFFFFF;
            border-radius: 3px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 46px;

        }


    }
.biaozhu_yangshi{
    width: 20px;
    height: 20px;
    background-color: rgb(255, 5, 5);
    position:absolute;
    
    border-radius: 50%;
}
  .biaozhu_zi{
    position:absolute;
    font-size: 15px;
    line-height:20px;
    left: 6px;
    color: rgb(248, 248, 248);
  }

</style>